import type {
  CreateDeficiencyRequestPayload,
  DeficiencyDocument,
} from "@services/deficiencies/types";
import type { Company } from "@services/vessel-call/types";
import type { Vessel } from "@services/vessel/types";
import { CREATE_DEFICIENCY_FIELDS as F } from "./constants";
import type { CreateDeficiencyFormData } from "./schema";

const getShippingAgencyName = (vessel: Vessel, companies: Company[]) => {
  return companies.find((company) => company.companyCode === vessel.companyId)?.companyNameEnglish;
};

const getLoaValue = (loa?: number) => {
  if (loa == null || Number.isNaN(loa)) {
    return "";
  }

  return String(loa);
};

export const mapRegisteredVesselToDeficiencyFormValues = (
  vessel: Vessel,
  companies: Company[],
): Pick<CreateDeficiencyFormData, "vesselName" | "shippingAgency" | "loa"> => ({
  [F.VESSEL_NAME]: vessel.vesselName ?? "",
  [F.SHIPPING_AGENCY]: getShippingAgencyName(vessel, companies),
  [F.LOA]: getLoaValue(vessel.loa),
});

export const mapCreateDeficiencyFormToPayload = (
  values: CreateDeficiencyFormData,
  documents: DeficiencyDocument[] = [],
): CreateDeficiencyRequestPayload => ({
  vesselImoNumber: Number(values.imoNo),
  vesselName: values.vesselName?.trim() ?? "",
  shippingAgency: values.shippingAgency?.trim() ?? "",
  tripNoPlda: values.tripNoPlda.trim(),
  berthVisitedCode: values.berthVisited.trim(),
  loa: values.loa?.trim().length ? Number(values.loa) : null,
  deficiencyDetails: values.deficiencyDetails.trim(),
  remarks: values.remarks?.trim() || undefined,
  documents: documents
    .filter((document) => document.documentUrl.trim().length > 0)
    .map((document) => ({
      documentUrl: document.documentUrl,
      documentName: document.documentName,
    })),
});
